module.exports = __webpack_public_path__ + "img/si-glyph-pin-location-white.e9058d99.svg";